import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=4a36fcf8"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports